module.exports = __webpack_public_path__ + "static/media/27a.8476febb.jpg";